import React from 'react';
import { Row, Col, CustomLink, SubTitle, Body, styled } from '@teko/ds-desktop';
import { BlockHeader } from '../BlockHeader/BlockHeader.es.js';
import { EnhancedImage } from '../EnhancedImage/EnhancedImage.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const PromoteBlock = ({
  header,
  contentItems,
  bottomImages,
  banner
}) => {
  return /* @__PURE__ */ React.createElement(Block, null, /* @__PURE__ */ React.createElement(BlockHeader, __spreadValues({}, header)), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, {
    span: 4
  }, /* @__PURE__ */ React.createElement(EnhancedImage, __spreadProps(__spreadValues({
    hover: "zoom",
    googleImageParams: { width: 400 },
    height: "100%",
    objectFit: "cover"
  }, banner), {
    alt: header.title
  }))), /* @__PURE__ */ React.createElement(Col, {
    span: 8
  }, /* @__PURE__ */ React.createElement(ContentItemsWrapper, null, contentItems.map((item, index) => /* @__PURE__ */ React.createElement(CustomLink, __spreadProps(__spreadValues({}, item.link), {
    key: index
  }), /* @__PURE__ */ React.createElement(ContentItem, {
    key: index
  }, /* @__PURE__ */ React.createElement(SubTitle, {
    level: 2,
    line: 1
  }, item.name), /* @__PURE__ */ React.createElement(Body, {
    level: 1,
    marginBottom: "s24",
    line: 1
  }, item.description), /* @__PURE__ */ React.createElement(EnhancedImage, __spreadProps(__spreadValues({
    hover: "zoom",
    googleImageParams: {
      width: 300
    },
    height: "94px",
    objectFit: "contain"
  }, item.image), {
    alt: item.name
  })))))))), bottomImages && /* @__PURE__ */ React.createElement(Footer, null, bottomImages.map((item, index) => /* @__PURE__ */ React.createElement(EnhancedImage, __spreadProps(__spreadValues({
    hover: "zoom",
    key: index,
    height: "68px",
    googleImageParams: { width: 200 },
    objectFit: "contain"
  }, item), {
    alt: item.alt || ""
  })))));
};
const ContentItemsWrapper = styled(Col)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1px;
  background-color: #e0e0e0;
`;
const ContentItem = styled.div(({ theme }) => `
  text-align: center;
  padding: 1rem;
  background-color: ${theme == null ? void 0 : theme.colors.white};
  height: 100%;
  &:hover {
    color: ${theme == null ? void 0 : theme.colors.primary500};
  }
`);
const Block = styled.div`
  background: white;
  border-radius: 8px;
  overflow: hidden;
`;
const Footer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export { PromoteBlock };
